<template>
  <div id="count" class="content">
    <p class="fTitle"><label style="margin-left: 15px;">完善信息</label></p>
    <div class="conten-box">
      <p class="sTitle">
        <span class="base-msg-title">基本信息</span>
        <!--<span class="msg-complete-percent">资料完整度：<label class="percent">30%</label></span>-->
      </p>
      <div class="form-box">
        <el-alert title="完善更多信息，有助于我们提供更加个性化的服务，HOTi将尊重并保护您的隐私" type="warning" :closable="false">
        </el-alert>
        <el-form>
          <el-form-item label="用户类型：" label-width="140px">
            <el-radio v-model="userType" v-if="this.nowuserType == '2' || this.nowuserType == '4'"
              label="2">组织用户</el-radio>
            <el-radio v-model="userType" v-if="this.nowuserType == '3' || this.nowuserType == '4'"
              label="3">个人用户</el-radio>
          </el-form-item>
        </el-form>
        <!--组织用户-->
        <el-form :rules="organFormRules" :model="organForm" v-show="userType == '2'" ref="organForm" label-width="150px"
          class="mes-form">
          <el-form-item label="组织名称：" prop="name">
            <el-input :disabled="organForm.notAllowChange1" v-model="organForm.name" placeholder="请输入组织名称"></el-input>
          </el-form-item>
          <el-form-item label="组织地址：" prop="address">
            <provice-city :notAllowChange="organForm.notAllowChange1" ref="provinceCity"
              @changeProCityVal="changeProCityVal"></provice-city>
            <el-input :disabled="organForm.notAllowChange1" v-model="organForm.address" style="width: 240px;"
              placeholder="请输入组织地址"></el-input>
          </el-form-item>
          <el-form-item label="联系电话：" prop="contact">
            <el-input :disabled="organForm.notAllowChange1" v-model="organForm.contact" class="w470"
              placeholder="请输入组织联系方式"></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码：">
            <el-input :disabled="organForm.notAllowChange2" v-model="organForm.uscc" class="w470"
              placeholder="请输入统一社会信用代码"></el-input>
            <span style="margin-top:0" class="red-tip">提示：非必填，但提交后不可修改</span>
          </el-form-item>
          <el-alert title="组织管理员" type="info" :closable="false" class="organ-el-alert">
          </el-alert>
          <el-form-item label="证件类型：" prop="adminCredentialsType">
            <el-select v-model="organForm.adminCredentialsType" placeholder="请选择证件类型">
              <el-option label="身份证" value="1"></el-option>
              <el-option label="护照" value="2"></el-option>
            </el-select>
          </el-form-item>

          <!-- 组织 上传身份证-->
          <!--<el-form-item label="上传证件：" prop="credentialsFrontFile" v-if="organForm.adminCredentialsType=='1'">-->
          <!--<el-upload-->
          <!--class="avatar-uploader"-->
          <!--accept="image/*"-->
          <!--:show-file-list="false"-->
          <!--:action="url"-->
          <!--prop="shenfzheng"-->
          <!--name="credentialsFrontFile"-->
          <!--:on-success="organFrontImgSucc"-->
          <!--:before-upload="beforeOrganFrontUpload">-->
          <!--<img v-if="organFrontImg" :src="organFrontImg" class="upload-bg">-->
          <!--<i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
          <!--</el-upload>-->
          <!--<el-upload-->
          <!--class="avatar-uploader"-->
          <!--accept="image/*"-->
          <!--action=""-->
          <!--name="credentialsBackFile"-->
          <!--:show-file-list="false"-->
          <!--:on-success="organBackImgSucc"-->
          <!--:before-upload="beforeOrganBackUpload" style="margin-left: 20px;">-->
          <!--<img v-if="organBackImg" :src="organBackImg" class="upload-bg">-->
          <!--<i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
          <!--</el-upload>-->
          <!--<span class="red-tip">提示：限制文件大小1M；</span>-->
          <!--</el-form-item>-->
          <!---->
          <!-- 组织 上传护照 -->
          <!--<el-form-item label="上传护照：" prop="credentialsFrontFile" v-if="organForm.adminCredentialsType=='2'">-->
          <!--<el-upload-->
          <!--class="avatar-uploader"-->
          <!--accept="image/*"-->
          <!--:show-file-list="false"-->
          <!--:action="url"-->
          <!--prop="shenfzheng"-->
          <!--name="credentialsFrontFile"-->
          <!--:before-upload="beforeOrganFrontUpload_noperson">-->
          <!--<img v-if="organFrontImg" :src="organFrontImg" class="upload-bg">-->
          <!--<i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
          <!--</el-upload>-->
          <!--<span class="red-tip">提示：限制文件大小1M；</span>-->
          <!--</el-form-item>-->

          <el-form-item label="管理员姓名：" prop="adminName">
            <el-input v-model="organForm.adminName" class="w470" placeholder="请输入管理员姓名"></el-input>
          </el-form-item>
          <el-form-item label="证件号码：" prop="adminCredentialsNo">
            <el-input v-model="organForm.adminCredentialsNo" class="w470" placeholder="请输入证件号码"></el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" style="background-color: #ff6000;border-color: #ff6000;width: 100px;"
              @click="submitOrganForm('organForm')">提交
            </el-button>
          </el-form-item>
          <p class="tips">
            重要提示：在本系统完成注册的组织或个人，其相关信息仅用于中国花样滑冰等级测试报名、成绩查询等业务场景，并不等同于已获得中国花样滑冰协会认可的有效俱乐部或注册运动员资质。俱乐部注册审核和运动员注册工作，请参考相关要求。
          </p>

        </el-form>
        <!--个人用户-->
        <el-form :model="mesForm" :rules="mesFormRules" v-show="userType == '3'" ref="mesForm" label-width="140px"
          class="mes-form">
          <el-form-item label="证件类型：" style="width: 450px;"  prop="credentialsType">
            <el-select :disabled="mesForm.notAllowChange" v-model="mesForm.credentialsType" placeholder="请选择证件类型"  style="width: 100%;">
              <el-option label="身份证" value="1"></el-option>
              <el-option label="护照" value="2"></el-option>
              <!-- <el-option label="户口本" value="3"></el-option> -->
            </el-select>
          </el-form-item>

          <!--&lt;!&ndash; 个人 上传身份证正反面 &ndash;&gt;-->
          <!--<el-form-item label="上传身份证：" prop="credentialsFrontFile" v-if="mesForm.credentialsType=='1'">-->
          <!--<el-upload-->
          <!--class="avatar-uploader"-->
          <!--:action="url"-->
          <!--accept="image/*"-->
          <!--:show-file-list="false"-->
          <!--name="credentialsFrontFile"-->
          <!--:on-success="personFrontImgSucc"-->
          <!--:before-upload="beforeIDFrontUpload">-->
          <!--<img v-if="personFrontImg" :src="personFrontImg" class="upload-bg">-->
          <!--<i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
          <!--</el-upload>-->
          <!--<el-upload-->
          <!--class="avatar-uploader"-->
          <!--action=""-->
          <!--accept="image/*"-->
          <!--:show-file-list="false"-->
          <!--name="credentialsBackFile"-->
          <!--:on-success="personBackImgSucc"-->
          <!--:before-upload="beforeIDBackUpload" style="margin-left: 20px;">-->
          <!--<img v-if="personBackImg" :src="personBackImg" class="upload-bg">-->
          <!--<i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
          <!--</el-upload>-->
          <!--<span class="red-tip">提示：限制文件大小1M；</span>-->
          <!--</el-form-item>-->
          <!--&lt;!&ndash; 个人 上传护照 &ndash;&gt;-->
          <!--<el-form-item label="上传护照：" prop="credentialsFrontFile" v-if="mesForm.credentialsType=='2'">-->
          <!--<el-upload-->
          <!--class="avatar-uploader"-->
          <!--:action="url"-->
          <!--accept="image/*"-->
          <!--:show-file-list="false"-->
          <!--name="credentialsFrontFile"-->
          <!--:before-upload="beforeIDFrontUpload_noperson">-->
          <!--<img v-if="personFrontImg" :src="personFrontImg" class="upload-bg">-->
          <!--<i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
          <!--</el-upload>-->
          <!--<span class="red-tip">提示：限制文件大小1M；</span>-->
          <!--</el-form-item>-->
          <!--&lt;!&ndash; 个人 上传户口本 &ndash;&gt;-->
          <!--<el-form-item label="上传户口本：" prop="credentialsFrontFile" v-if="mesForm.credentialsType=='3'">-->
          <!--<el-upload-->
          <!--accept="image/*"-->
          <!--class="avatar-uploader"-->
          <!--:action="url"-->
          <!--:show-file-list="false"-->
          <!--name="credentialsFrontFile"-->
          <!--:before-upload="beforeIDFrontUpload_noperson">-->
          <!--<img v-if="personFrontImg" :src="personFrontImg" class="upload-bg">-->
          <!--<i v-else class="el-icon-plus avatar-uploader-icon"></i>-->
          <!--</el-upload>-->
          <!--<span class="red-tip">提示：限制文件大小1M；</span>-->
          <!--</el-form-item>-->

          <el-form-item label="证件号码：" style="width: 450px;" prop="credentialsNo">
            <el-input :disabled="mesForm.notAllowChange" v-model="mesForm.credentialsNo"
              placeholder="请输入证件号码"></el-input>
          </el-form-item>
          <el-form-item label="真实姓名：" style="width: 450px;" prop="name">
            <el-input :disabled="mesForm.notAllowChange" v-model="mesForm.name" placeholder="请输入真实姓名"></el-input>
          </el-form-item>
          <!-- <el-form-item label="原等级测试ID" v-if="false" class="w470" prop="oldLvId">
            <el-input v-model="mesForm.oldLvId" placeholder="请输入原等级测试ID"></el-input>
          </el-form-item> -->
          <el-form-item label="性别：" style="width: 450px;"  prop="sex">
            <el-select :disabled="mesForm.notAllowChange" v-model="mesForm.sex" placeholder="请选择性别"  style="width: 100%;" >
              <el-option label="男" value="1"></el-option>
              <el-option label="女" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="出生日期：" style="width: 450px;"  class="w217" prop="birthday">
            <el-date-picker v-model="mesForm.birthday" type="date" :disabled="mesForm.notAllowChange"
              format="yyyy/MM/dd" value-format="yyyy/MM/dd" placeholder="请输入出生日期"   style="width: 100%;">
            </el-date-picker>
          </el-form-item>

          <el-form-item>
            <el-button v-if="!mesForm.notAllowChange" type="primary"
              style="background-color: #5a5cbb;border-color: #5a5cbb;width: 100px;" @click="clickFun('mesForm')">提交
            </el-button>
          </el-form-item>
          <p class="tips">
            重要提示：在本系统完成注册的组织或个人，其相关信息仅用于中国花样滑冰等级测试报名、成绩查询等业务场景，并不等同于已获得中国花样滑冰协会认可的有效俱乐部或注册运动员资质。俱乐部注册审核和运动员注册工作，请参考相关要求。
          </p>

        </el-form>

      </div>
    </div>
    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="30%">
      <span>基本信息提交后不可修改，提交前请严格核对。如因用户自身填报错误无法正确报名，请联系客服人工修改，手续费50元/次，费用由用户承担。</span>
      <span slot="footer" class="dialog-footer">
        <el-checkbox v-model="agree" label="我同意并已阅读" name="type" style="float: left"></el-checkbox>
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="!agree" @click="submitMesForm('mesForm')">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>
<script>
import { get, post } from '@/api/fetch.js';
import url from '@/api/serviceAPI.config.js';
import zheng from '@/assets/images/idback.png';
import fan from '@/assets/images/identity.png';
import axios from 'axios';
import proviceCity from "../provinceCity/proviceCity";
import util from '@/util'
export default {
  data() {
    // 个人用户证件上传自定义规则
    let equitMesCredentialsFrontFile = (rule, value, callback) => {
      if (this.mesForm.credentialsType === '1') {
        if (this.mesForm.credentialsFrontFile == '' || this.mesForm.credentialsBackFile == '') {
          callback(new Error('请上传证件照'));
        } else {
          callback();
        }
      } else {
        if (this.mesForm.credentialsFrontFile == '') {
          callback(new Error('请上传证件照'));
        } else {
          callback();
        }
      }
    }
    // 组织用户证件上传自定义规则
    let equitOrganCredentialsFrontFile = (rule, value, callback) => {
      if (this.organForm.adminCredentialsType === '1') {
        if (this.organForm.credentialsFrontFile == '' || this.organForm.credentialsBackFile == '') {
          callback(new Error('请上传证件照'));
        } else {
          callback();
        }
      } else {
        if (this.organForm.credentialsFrontFile == '') {
          callback(new Error('请上传证件照'));
        } else {
          callback();
        }
      }
    }

    let validateCredentialsNo = (rule, value, callback) => {
      console.log(2323,this.organForm.adminCredentialsType);
      console.log(2234,this.mesForm.credentialsType);
      if (this.organForm.adminCredentialsType == 1 ||this.mesForm.credentialsType == 1) {
        console.log(1);
        if (value == '') {
          callback(new Error('请输入身份证号码'));
        } else if (/\s/g.test(value)) {
          callback(new Error('请勿输入空格'));
        }
        else if (!/^[0-9]{17}([0-9]|X)$/.test(value)) {
          callback(new Error('请输入正确的身份证号码,如果最后一位为X,请大写'));
        }
        else {
          callback();
        }
      } else if (this.organForm.adminCredentialsType == 2||this.mesForm.credentialsType == 2) {
        console.log(2);
        if (value == '') {
          callback(new Error('请输入证件号码'));
        } else if (/\s/g.test(value)) {
          callback(new Error('请勿输入空格'));
        }
        // 只能输入数字和字符
        else if (!/^[0-9a-zA-Z()]+$/.test(value)) {
          callback(new Error('只能输入数字和字母及英文小括号'));
        }
        else {
          callback();
        }
      }else{
        callback(new Error('请先选择证件类型！'));
      }
    }
    return {
      token: sessionStorage.getItem("ACCESS_TOKEN"),
      centerDialogVisible: false,
      agree: false,
      organTypeChangeNumber: 0,
      personTypeChangeNumber: 0,
      url: url.discern,
      accountId: '',
      id: null,//已经确认为组织或个人用户，二次编辑时使用
      personFrontImg: zheng,//个人身份证正面
      personBackImg: fan,//个人身份证背面
      organFrontImg: zheng,//组织身份证正面
      organBackImg: fan,//组织身份证背面
      userType: "2",
      nowuserType: '',
      organForm: {//组织用户
        name: '',
        adminCredentialsType: null,
        credentialsFrontFile: '',//组织证件正面
        credentialsBackFile: '',//组织证件背面
        adminName: '',
        adminCredentialsNo: '',
        contact: '',
        uscc: '',
        province: '',
        city: '',
        address: '',
        id: '',
      },
      mesForm: {//个人用户
        credentialsType: null,
        credentialsNo: '',
        credentialsFrontFile: '',//个人身份证正面
        credentialsBackFile: '',//个人身份证背面
        sex: '1',
        birthday: '',
        name: '',
        // oldLvId: '',
        id: '',
      },
      mesFormRules: {
        birthday: [
          { required: true, message: '请输入出生日期', trigger: 'blur' },
        ],
        credentialsNo: [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
          { validator: validateCredentialsNo, trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
        ],
        credentialsType: [
          { required: true, message: '请选择证件类型', trigger: 'blur' }
        ],
        credentialsFrontFile: [
          { required: false, validator: equitMesCredentialsFrontFile, trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '请选择性别', trigger: 'blur' }
        ]
      },
      organFormRules: {
        credentialsFrontFile: [
          { required: false, validator: equitOrganCredentialsFrontFile, trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入组织名称', trigger: 'blur' },
        ],
        adminName: [
          { required: true, message: '请输入管理员姓名', trigger: 'blur' },
        ],
        adminCredentialsNo: [
          { required: true, message: '请输入证件号码', trigger: 'blur' },
          { validator: validateCredentialsNo, trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请输入联系方式', trigger: 'blur' },
  //         { 
  //   validator: (rule, value, callback) => {
  //     if (!value) {
  //       callback(new Error('请输入手机号'));
  //     } else if (!/^1[3-9]\d{9}$/.test(value)) {
  //       callback(new Error('请输入正确的手机号格式'));
  //     } else {
  //       callback();
  //     }
  //   },
  //   trigger: 'blur'
  // }
        ],
        address: [
          { required: true, message: '请选择地址', trigger: 'blur' },
        ],
        adminCredentialsType: [
          { required: true, message: '请选择证件类型', trigger: 'blur' }
        ]
      }
    };
  },
  beforeMount() {
    console.log('beforeMount')
    console.log(this.personFrontImg)
  },
  components: { proviceCity },
  mounted() {
    this.accountId = JSON.parse(sessionStorage.getItem("user")).id;
    this.userType = JSON.parse(sessionStorage.getItem("user")).type;
    this.nowuserType = JSON.parse(sessionStorage.getItem("type"));
    if (JSON.parse(sessionStorage.getItem("user")).type == '2') {//组织用户
      let vm = this;
      // 创建实例时设置配置的默认值
      var instance = axios.create();
      // 在实例已创建后修改默认值
      instance.defaults.headers.post['Content-Type'] = 'application/json';
      if (this.token) instance.defaults.headers.token = this.token;
      instance.post(url.getOrganMsg, { id: vm.accountId }).then(res => {
        let data = res.data;
        if (data.status == 200) {
          vm.id = data.data.id;
          vm.organForm.name = data.data.name;
          vm.organForm.adminCredentialsType = data.data.adminCredentialsType;
          vm.organForm.adminName = data.data.adminName;
          vm.organForm.adminCredentialsNo = data.data.adminCredentialsNo;
          vm.organForm.contact = data.data.contact;
          vm.organForm.uscc = data.data.uscc;
          vm.organForm.province = data.data.province;
          vm.organForm.city = data.data.city;

          if (vm.organForm.name) vm.organForm.notAllowChange1 = true;  //必填项的
          if (vm.organForm.uscc) vm.organForm.notAllowChange2 = true;    //统一社会信用代码

          vm.$refs.provinceCity.pm = data.data.province;
          vm.$refs.provinceCity.cm = data.data.city;
          vm.organForm.address = data.data.address;
          if (data.data.adminCredentialsFrontUrl !== null) {
            vm.organFrontImg = data.data.adminCredentialsFrontUrl + '?v=' + Math.random();
          }
          if (data.data.adminCredentialsBackUrl !== null) {
            vm.organBackImg = data.data.adminCredentialsBackUrl + '?v=' + Math.random();
          }
          //vm.organForm.credentialsFrontFile = res.data.credentialsFrontFile;
          //vm.organForm.credentialsBackFile = res.data.credentialsBackFile;
          //vm.organFrontImg = '';
          //vm.organBackImg = '';

        } else {
          vm.$notify({
            title: data.message,
            type: 'error'
          });
        }
      });
    }
    if (JSON.parse(sessionStorage.getItem("user")).type == '3') {//个人用户
      let vm = this;
      // 创建实例时设置配置的默认值
      var instance = axios.create();
      // 在实例已创建后修改默认值
      instance.defaults.headers.post['Content-Type'] = 'application/json';
      if (this.token) instance.defaults.headers.token = this.token;
      instance.post(url.getPersonMsg, { id: vm.accountId }).then(res => {
        let data = res.data;
        if (data.status == 200) {
          vm.id = res.data.id;
          vm.mesForm.credentialsType = data.data.credentialsType;
          vm.mesForm.credentialsNo = data.data.credentialsNo;

          if (vm.mesForm.credentialsNo) vm.mesForm.notAllowChange = true;
          //vm.mesForm.credentialsFrontFile = res.data.credentialsFrontFile;
          // vm.mesForm.credentialsBackFile = res.data.credentialsBackFile;
          vm.mesForm.sex = data.data.sex;
          let bir = data.data.birthday;
          bir = bir ? bir.replace(/\-/g, '/') : ''
          vm.mesForm.birthday = bir;
          vm.mesForm.name = data.data.name;
          // vm.mesForm.oldLvId = data.data.oldLvId;
          if (data.data.credentialsFrontUrl !== null) {
            vm.personFrontImg = data.data.credentialsFrontUrl + '?v=' + Math.random();
          }
          if (data.data.credentialsBackUrl !== null) {
            vm.personBackImg = data.data.credentialsBackUrl + '?v=' + Math.random();
          }
          console.log(vm.personBackImg)
          vm.mesForm.id = data.data.id;
          console.log('mesForm', vm.mesForm);
        } else {
          vm.$notify({
            title: res.message,
            type: 'error'
          });
        }
      });
    }
  },
  methods: {
    submitOrganForm(formName) {//组织
      let vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          let pm = new FormData();
          if (vm.id) {
            pm.append('id', vm.id);
          }
          pm.append("name", vm.organForm.name);
          pm.append("accountId", vm.accountId);
          pm.append("adminCredentialsType", vm.organForm.adminCredentialsType);
          pm.append("credentialsFrontFile", vm.organForm.credentialsFrontFile);
          pm.append("credentialsBackFile", vm.organForm.credentialsBackFile);
          pm.append("adminName", vm.organForm.adminName);
          pm.append("adminCredentialsNo", vm.organForm.adminCredentialsNo);
          pm.append('contact', vm.organForm.contact);
          pm.append('uscc', vm.organForm.uscc);
          pm.append('province', vm.organForm.province);
          pm.append('city', vm.organForm.city);
          pm.append('address', vm.organForm.address);
          let organAxios = axios.create();
          organAxios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
          if (this.token) {
            organAxios.defaults.headers.token = this.token
          }
          organAxios.post(url.saveOrgan, pm).then(res => {
            if (res.data.status == 200) {
              vm.$notify({
                title: '保存成功',
                type: 'success'
              });
              let oldUserMsg = JSON.parse(sessionStorage.getItem('user'));//保存成功后，sessionStorage里user的type需要刷新
              oldUserMsg.type = '2';
              sessionStorage.setItem('user', JSON.stringify(oldUserMsg));
              vm.$router.push({ path: '/index/applyPage' });
            } else {
              vm.$notify({
                title: res.data.message,
                type: 'error',
              });
            }
          }).catch(error => { })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    clickFun(formName) {
      console.log('当前执行性');
      let vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          console.log('已经校验');
          get(url.findLevelByCredentialsNo + '?credentialsNo=' + this.mesForm.credentialsNo).then(res => {
            if (res.status == 200) {
              if (res.data != null) {
                var str = '您当前等级：自由滑' + res.data.fsLevel + "，步法" + res.data.siLevel + "，成人" + res.data.adLevel
                this.$alert(str, '提示', {
                  confirmButtonText: '确定',
                  callback: action => {
                  }
                });
              } else {
                this.centerDialogVisible = true
              }
            }
          })
        }
      })
    },
    submitMesForm(formName) {//个人
      let vm = this;
      vm.$refs[formName].validate((valid) => {
        if (valid) {
          let pm = new FormData();
          if (vm.id) {
            pm.append('id', vm.id);
          }
          pm.append("accountId", vm.accountId);
          pm.append("credentialsType", vm.mesForm.credentialsType);
          pm.append("credentialsNo", vm.mesForm.credentialsNo);
          pm.append("sex", vm.mesForm.sex);
          pm.append("birthday", vm.mesForm.birthday);
          pm.append("name", vm.mesForm.name);
          // pm.append("oldLvId", vm.mesForm.oldLvId);
          pm.append("id", vm.mesForm.id);
          pm.append('credentialsFrontFile', vm.mesForm.credentialsFrontFile);
          console.log('正面')
          console.log(vm.mesForm.credentialsFrontFile)
          pm.append('credentialsBackFile', vm.mesForm.credentialsBackFile);
          console.log('反面')
          console.log(vm.mesForm.credentialsBackFile)
          let perAxios = axios.create();
          perAxios.defaults.headers.post['Content-Type'] = 'multipart/form-data';
          if (this.token) {
            perAxios.defaults.headers.token = this.token;
          }
          perAxios.post(url.savePerson, pm).then(res => {
            this.centerDialogVisible = true;
            if (res.data.status == 200) {
              vm.$notify({
                title: '保存成功',
                type: 'success'
              });
              let oldUserMsg = JSON.parse(sessionStorage.getItem('user'));
              oldUserMsg.type = '3';
              sessionStorage.setItem('user', JSON.stringify(oldUserMsg));
              sessionStorage.setItem('type', JSON.stringify(3));
              vm.$router.push({ path: 'orderList' });
            } else {
              vm.$notify({
                title: res.data.message,
                type: 'error',
              });
            }
          }).catch(error => {
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    organFrontImgSucc(res, file, imageUrl) { //组织证件正面success
      let vm = this;
      let data = res.data;
      if (res.status == 200 && data.result == "true") {
        vm.organForm.adminName = data.name;
        vm.organForm.adminCredentialsNo = data.idNumber;
        vm.mesForm.sex = data.gender;
        this.$notify({
          title: '识别成功',
          message: '身份证识别成功，请核对身份信息是否正确！',
          type: 'success'
        });
      }
      this.organFrontImg = URL.createObjectURL(file.raw);
    },
    organBackImgSucc(res, file, imageUrl) {//组织证件背面success
      this.organBackImg = URL.createObjectURL(file.raw);
    },
    beforeOrganFrontUpload(file) {//组织证件正面before上传
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$notify({
          title: '错误提示',
          message: '上传头像图片大小不能超过 1M !',
          type: 'error'
        });
      }
      this.organForm.credentialsFrontFile = file;
      this.organFrontImg = URL.createObjectURL(file);
    },
    beforeOrganBackUpload(file) {//组织证件背面before上传
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$notify({
          title: '错误提示',
          message: '上传头像图片大小不能超过 1M !',
          type: 'error'
        });
      }
      this.organBackImg = URL.createObjectURL(file);
      this.organForm.credentialsBackFile = file;
    },
    // 组织用户 护照上传不需识别，因此需要阻止上传
    beforeOrganFrontUpload_noperson(file) {
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$notify({
          title: '错误提示',
          message: '上传头像图片大小不能超过 1M !',
          type: 'error'
        });
      }
      this.organForm.credentialsFrontFile = file;
      //创建临时的路径来展示图片
      var windowURL = window.URL || window.webkitURL;
      this.organFrontImg = windowURL.createObjectURL(file);
      return false;
    },
    personFrontImgSucc(res, file, imageUrl) {//个人身份证正面success
      let vm = this;

      let data = res.data;

      if (res.status == 200 && data.result == "true") {
        vm.mesForm.name = data.name;
        vm.mesForm.credentialsNo = data.idNumber;
        vm.mesForm.sex = data.gender;
        this.$notify({
          title: '识别成功',
          message: '身份证识别成功，请核对身份信息是否正确！',
          type: 'success'
        });
      }
      console.log(URL.createObjectURL(file.raw));
      this.personFrontImg = URL.createObjectURL(file.raw);
    },
    personBackImgSucc(res, file, imageUrl) {//个人身份证背面success
      this.personBackImg = URL.createObjectURL(file.raw);
    },
    beforeIDFrontUpload(file) {//个人身份证正面before上传
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$notify({
          title: '错误提示',
          message: '上传头像图片大小不能超过 1M !',
          type: 'error'
        });
      }
      this.mesForm.credentialsFrontFile = file;
      this.personFrontImg = URL.createObjectURL(file);
    },
    // 个人用户 护照，户口本上传不需识别，因此需要阻止上传
    beforeIDFrontUpload_noperson(file) {
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$notify({
          title: '错误提示',
          message: '上传头像图片大小不能超过 1M !',
          type: 'error'
        });
      }
      this.mesForm.credentialsFrontFile = file;
      //创建临时的路径来展示图片
      var windowURL = window.URL || window.webkitURL;
      this.personFrontImg = windowURL.createObjectURL(file);
      return false;
    },
    beforeIDBackUpload(file) {//个人身份证背面before上传
      console.log('阻止个人身份证背面上传')
      const isLt2M = file.size / 1024 / 1024 < 1;
      if (!isLt2M) {
        this.$notify({
          title: '错误提示',
          message: '上传头像图片大小不能超过 1M !',
          type: 'error'
        });
      }
      this.personBackImg = URL.createObjectURL(file);
      this.mesForm.credentialsBackFile = file;
    },
    changeProCityVal(val) {
      this.organForm.province = val.pro;
      this.organForm.city = val.city;
    },
  },
  watch: {
    'mesForm.credentialsType': function (newValue) {
      this.personTypeChangeNumber++;
      if (this.personTypeChangeNumber !== 1) {
        this.personBackImg = fan;
        this.mesForm.credentialsBackFile = '';
        this.personFrontImg = zheng;
        this.mesForm.credentialsFrontFile = '';
      }
    },
    'organForm.adminCredentialsType': function (newValue) {

      this.organTypeChangeNumber++;
      console.log(this.organTypeChangeNumber)
      if (this.organTypeChangeNumber !== 1) {
        this.organBackImg = fan;
        this.organForm.credentialsBackFile = '';
        this.organFrontImg = zheng;
        this.organForm.credentialsFrontFile = '';
      }
    },
    personFrontImg(newValue, oldValue) {
      if (this.mesForm.credentialsFrontFile === '' && newValue !== zheng) {
        let suffix = newValue.split('.').pop()
        util.getImgToBase64(newValue, data => {
          var myFile = util.dataURLtoFile(data, `filename.${suffix}`);
          console.log(myFile);
          this.mesForm.credentialsFrontFile = myFile;
        })
      }
    },
    personBackImg(newValue, oldValue) {
      // imgsrc 变化，且证件文件===''且imgsrc不为默认的空，才根据imgsrc生成file
      if (this.mesForm.credentialsBackFile === '' && newValue !== fan) {
        let suffix = newValue.split('.').pop()
        util.getImgToBase64(newValue, data => {
          var myFile = util.dataURLtoFile(data, `filename.${suffix}`);
          console.log(myFile);
          this.mesForm.credentialsBackFile = myFile;
        })
      }
    },
    organFrontImg(newValue, oldValue) {
      if (this.organForm.credentialsFrontFile === '' && newValue !== zheng) {
        let suffix = newValue.split('.').pop()
        util.getImgToBase64(newValue, data => {
          var myFile = util.dataURLtoFile(data, `filename.${suffix}`);
          console.log(myFile);
          this.organForm.credentialsFrontFile = myFile;
        })
      }
    },

    organBackImg(newValue, oldValue) {
      if (this.organForm.credentialsBackFile === '' && newValue !== fan) {
        let suffix = newValue.split('.').pop()
        util.getImgToBase64(newValue, data => {
          var myFile = util.dataURLtoFile(data, `filename.${suffix}`);
          console.log(myFile);
          this.organForm.credentialsBackFile = myFile;
        })
      }
    },
  }
}
</script>

<style type="text/scss" lang="scss" scoped>
.fTitle {
  height: 32px;
  line-height: 32px;
  width: 100%;
  background: #fefefe;
  border: 1px solid #ddd;
  margin-bottom: 20px;
  color: #a7a7a7;
}

.conten-box {
  .sTitle {
    width: 100%;
    border-bottom: 2px solid #5a5cbb;

    .base-msg-title {
      line-height: 30px;
      text-align: center;
      display: inline-block;
      height: 30px;
      padding: 0 28px;
      background: #5a5cbb;
      color: #fff;
      margin-left: 10px;
      font-size: 15px;
    }
  }

  .w470 {
    width: 470px;
  }

  .w217 {
    width: 217px;
  }

  .userType-label {
    display: inline-block;
    width: 100px;
    text-align: right;
    padding-right: 20px;
    font-size: 14px;
    color: #606266;
  }

  .organ-el-alert {
    margin-left: -15px;
    margin-right: -15px;
    width: auto;
    border-color: #ddd;
    background-color: #f4f4f5;
    color: #333;
  }

  .msg-complete-percent {
    float: right;
    line-height: 30px;
    color: #666;

    .percent {
      font-size: 30px;
      color: #5a5cbb;
    }
  }

  .upload-bg {
    display: block;
    width: 245px;
    height: 140px;
  }

  .form-box {
    padding: 10px 30px;
  }
}

.red-tip {
  color: red;
  margin-top: 110px;
  margin-left: 20px;
  display: inline-block;
}

.tips {
  text-align: left;
  margin-top: 10px;
  color: #f44;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/count.vue